import React from 'react'
import PropTypes from 'prop-types'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import MomentUtils from '@date-io/moment'
import moment from 'moment'
import 'moment/locale/ja'
moment.locale('ja')

class ExtendedMomentUtils extends MomentUtils {
  getCalendarHeaderText (date) {
    return moment(date).format('YYYY年MM月')
  }

  getDatePickerHeaderText (date) {
    return moment(date).format('MM 月 DD 日 (ddd)')
  }
}

export default function DatePickerProvider (props) {
  return (
    <MuiPickersUtilsProvider utils={ExtendedMomentUtils} locale='ja'>
      {props.children}
    </MuiPickersUtilsProvider>
  )
}

DatePickerProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ])
}
